export function getClauseURL({ playbookID, clauseID }: { playbookID: string; clauseID: string }) {
  return `https://app.pincites.com/playbooks/${playbookID}/clause/${clauseID}`;
}
